<div class="table-scroll" (click)="closeMenus()">
    <table class="data-table">
        <thead>
            <tr>
                @for (col of columns; track col.key) {
                    <th [class.is-sortable]="col.sortable" (click)="onSort(col)">
                        <span class="th-content">
                            <span>{{ col.label | translate }}</span>
                            @if (col.sortable) {
                                <svg class="sort-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M6 2.5V9.5M6 9.5L3 6.5M6 9.5L9 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            }
                        </span>
                    </th>
                }
                @if (actions.length) {
                    <th class="action-th">
                        <span class="th-content">
                            <span>{{ 'action' | translate }}</span>
                            <svg class="sort-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M6 2.5V9.5M6 9.5L3 6.5M6 9.5L9 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </th>
                }
            </tr>
        </thead>
        <tbody>
            @for (row of rows; track $index; let i = $index) {
                <tr>
                    @for (col of columns; track col.key) {
                        <td>
                            @if (col.key === linkColumnKey) {
                                <a class="table-link" (click)="onLinkClick(row); $event.preventDefault()">
                                    {{ getCellValue(row, col) }}
                                </a>
                            } @else {
                                @if (col.truncate) {
                                    <span class="cell-truncate" [title]="getCellValue(row, col)">
                                        {{ getCellValue(row, col) }}
                                    </span>
                                } @else {
                                    {{ getCellValue(row, col) }}
                                }
                            }
                        </td>
                    }
                    @if (actions.length) {
                        <td class="action-td">
                            <button type="button" class="action-btn" (click)="toggleMenu(i, $event)" aria-label="Open actions">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="3" r="1.5" fill="currentColor"/>
                                    <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
                                    <circle cx="8" cy="13" r="1.5" fill="currentColor"/>
                                </svg>
                            </button>
                            @if (openMenuIndex === i) {
                                <div class="action-menu" (click)="$event.stopPropagation()">
                                    @for (action of actions; track action.key) {
                                        <button
                                            type="button"
                                            class="action-menu-item"
                                            (click)="onActionClick(action.key, row, $event)"
                                        >
                                            {{ action.label | translate }}
                                        </button>
                                    }
                                </div>
                            }
                        </td>
                    }
                </tr>
            }
            @if (!rows.length) {
                <tr>
                    <td [attr.colspan]="columns.length + (actions.length ? 1 : 0)" class="empty-cell">
                        {{ 'noRecordsFound' | translate }}
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
